// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gauo","top":"styles_top__13wpl","left":"styles_left__32XEi","description":"styles_description__3tD13"};